import { License } from '@app/license-management/types/license'
import { Organization } from '@app/organization-management/types/organization'
import { AccessRole } from './access-role'
import { ProfessionalRole } from './professional-role'
import { UserStatus } from './user-status'
import { ISODateString } from '@app/common/types/iso-date-string'
import { LegacyLicense } from './legacy-license'
import { LicensePool } from '@app/license-management/types/license-pool'
import { getCustomerFacingLicenseName } from '@app/common/util/get-customer-facing-license-name'
import { getLicensePoolTitle } from '@app/common/util/get-license-pool-title'
import { OrderType } from '@app/organization-management/types/order-type'
import { BillingPlatform } from '@app/organization-management/types/billing-platform'
import { PilotMetadata } from './pilot-metadata'

export class User {
  userId!: string
  email!: string
  firstName!: string
  lastName!: string
  accessRole!: AccessRole
  professionalRole!: ProfessionalRole | null
  belongsToActivePilot!: boolean
  pilot?: boolean
  pilotMetaData?: PilotMetadata | null
  daysActive!: number
  lastActivityAt?: string | null
  activeDaysLog?: string[] | undefined
  license!: License
  status!: UserStatus
  statusUpdatedAt?: ISODateString | null
  organization?: Organization
  legacyLicense!: LegacyLicense | null
  licensePool!: LicensePool | null
  orderType?: OrderType

  licenseTypeDisplay(): string {
    if (this.organization?.billingPlatform === BillingPlatform.MAXIO) {
      if (!this.licensePool) {
        return 'N/A'
      }
      return this.licensePoolDisplay(this.licensePool)
    }

    if (this.legacyLicense?.subscription?.plan) {
      return (
        getCustomerFacingLicenseName({
          unlimitedLicenses: this.legacyLicense.subscription.plan.unlimitedLicenses,
        }) ?? 'N/A'
      )
    }

    if (this.licensePool) {
      return this.licensePoolDisplay(this.licensePool)
    }

    return 'N/A'
  }

  private licensePoolDisplay(pool: LicensePool): string {
    return getCustomerFacingLicenseName({ licensePool: pool }) ?? getLicensePoolTitle(pool)
  }
}
